import { render, staticRenderFns } from "./HeaderAuth.vue?vue&type=template&id=69c91b7e&"
import script from "./HeaderAuth.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HeaderAuth.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c91b7e')) {
      api.createRecord('69c91b7e', component.options)
    } else {
      api.reload('69c91b7e', component.options)
    }
    module.hot.accept("./HeaderAuth.vue?vue&type=template&id=69c91b7e&", function () {
      api.rerender('69c91b7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/HeaderAuth.vue"
export default component.exports